import type { AccessLockReason } from "@/types";

const ACCESS_LOCK_COPY_KEYS = {
  trial_ended: "accessLocked.trialEnded",
  payment_required: "accessLocked.paymentRequired",
  organization_blocked: "accessLocked.organizationBlocked",
} as const;

export function accessLockCopyKey(reason: AccessLockReason | null | undefined): string {
  if (!reason) return "accessLocked.generic";
  return ACCESS_LOCK_COPY_KEYS[reason] ?? "accessLocked.generic";
}

/** Where to send a locked user: pay/convert vs blocked support wall. */
export function resolveAccessLockRoute(reason: AccessLockReason | null | undefined): string {
  if (reason === "trial_ended" || reason === "payment_required") return "/billing";
  return "/access-locked";
}

